import { render, staticRenderFns } from "./dj-view-absolute.vue?vue&type=template&id=38d496ac&scoped=true&"
import script from "./dj-view-absolute.vue?vue&type=script&lang=js&"
export * from "./dj-view-absolute.vue?vue&type=script&lang=js&"
import style0 from "./dj-view-absolute.vue?vue&type=style&index=0&id=38d496ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d496ac",
  null
  
)

export default component.exports